let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9xsqt")).then(() => parcelRequire('9YNaf'));